var _defs, _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxCreditsAndTaxAllowancesOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    x1: 118.56,
    y1: 107.85,
    x2: 154.05,
    y2: 107.85,
    gradientTransform: "rotate(10.5 101.338 85.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 85.01,
    y1: 69.97,
    x2: 109.59,
    y2: 69.97,
    gradientTransform: "translate(-.34 .37)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 97.39,
    y1: 113.34,
    x2: 135.12,
    y2: 113.34,
    gradientTransform: "rotate(10.5 105.889 59.521) scale(1.05 1.01)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 113.12,
    y1: 92.39,
    x2: 122.75,
    y2: 92.39,
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 103.63,
    y1: 123.29,
    x2: 110.61,
    y2: 123.29,
    gradientTransform: "rotate(7.19 86.308 116.022)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 111.94,
    y1: 132.63,
    x2: 118.92,
    y2: 132.63,
    gradientTransform: "rotate(7.19 86.308 116.022)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 104.18,
    y1: 127.89,
    x2: 118.49,
    y2: 127.89,
    gradientTransform: "rotate(7.19 86.308 116.022)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 75.4,
    y1: 27.98,
    x2: 117.66,
    y2: 27.98,
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3",
    "data-name": "SVG_ID_0_5b562adc0d7cef43d36f71274e294915d89a5dd1dbfaa554416951b2b10879ae",
    x1: 77.4,
    y1: 40.33,
    x2: 119.66,
    y2: 40.33,
    gradientTransform: "translate(-2 -12.36)",
    xlinkHref: "#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M90.68 131.86l-28.52.11c-2.31 0-4.2-2.06-4.21-4.62l-.36-96.65c0-2.56 1.86-4.65 4.17-4.66l15.36-.06M115.31 25.84l15.59-.06c2.31 0 4.2 2.06 4.21 4.62l.24 60.32M107.23 69.48a8.168 8.168 0 017.55-5.11c3.86-.01 7.1 2.65 7.97 6.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M70.26 70.94c.79-3.66 4.05-6.42 7.95-6.43a8.155 8.155 0 018.15 7.3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 114.96,
    cy: 59.71,
    rx: 4.75,
    ry: 4.67,
    transform: "translate(-.22 .43)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.35,
    cy: 57.4,
    rx: 6.71,
    ry: 6.6,
    transform: "translate(-.22 .37)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.2,
    cy: 59.85,
    rx: 4.75,
    ry: 4.67,
    transform: "translate(-.23 .3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.4 75.4c.55-6.04 5.62-10.78 11.8-10.8 6.16-.02 11.24 4.63 11.87 10.62",
    stroke: "url(#)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.4 75.4c.55-6.04 5.62-10.78 11.8-10.8 6.16-.02 11.24 4.63 11.87 10.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)",
    d: "M120.15 85.69l2.86-3.09 17.08 11.74 3.26 47.17-16.98.98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)",
    d: "M98.21 93.6l20.12-9.66 15.74 16.31-9.68 52.18-36.52-6.56L98.21 93.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 116.46,
    cy: 95.3,
    r: 3.56,
    stroke: "url(#SVGID_3_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 106.04,
    cy: 125.83,
    r: 2.24,
    stroke: "url(#SVGID_4_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 113.12,
    cy: 136.15,
    r: 2.24,
    stroke: "url(#SVGID_5_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_6_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)",
    d: "M102.93 136.99l13.43-12.13"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_7_953f3a6ff76c3b91863a13d6555da99f8d5f2ba59a52e545206f994d361ea9a3)",
    d: "M112.5 33.61l4.06-11.27H76.51l4.05 11.27h31.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCreditsAndTaxAllowancesOverview);
export default __webpack_public_path__ + "static/media/taxCreditsAndTaxAllowancesOverview.74de0998a5d3358835d108fd8df37868.svg";
export { ForwardRef as ReactComponent };